(function () {
  function getProductInfo(fromEl) {
    return fromEl?.closest('product-info') || document.querySelector('product-info.pairfit-product-page');
  }

  function getProductForm(root) {
    return (root || document).querySelector('product-form form[data-type="add-to-cart-form"]');
  }

  function formatMoneyFromCents(cents) {
    const format =
      document.querySelector('[data-pairfit-money-format]')?.dataset.pairfitMoneyFormat || 'Rs{{amount}} PKR';
    const amount = (Number(cents) / 100).toFixed(2);
    const amountNoDecimals = String(Math.round(Number(cents) / 100));
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals);
  }

  function setButtonLoading(button, loading) {
    if (!button) return;
    button.classList.toggle('is-loading', loading);
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (loading) button.setAttribute('aria-disabled', 'true');
    else button.removeAttribute('aria-disabled');
  }

  function getQuantity(root) {
    const input = root?.querySelector('quantity-input [name="quantity"], .quantity__input, [name="quantity"]');
    const quantity = Number.parseInt(input?.value, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function isAlreadyInCartError(data) {
    const text = `${data?.description || ''} ${data?.message || ''}`.toLowerCase();
    return text.includes('already in your cart') || text.includes('maximum quantity');
  }

  function checkoutUrl() {
    const root = window.Shopify?.routes?.root || '/';
    return new URL('checkout', window.location.origin + root).pathname;
  }

  async function ensureVariantInCart(variantId, quantity) {
    const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await cartResponse.json();
    const existing = cart.items?.find(
      (item) => String(item.variant_id) === String(variantId) || String(item.id) === String(variantId)
    );

    if (existing && existing.quantity >= quantity) return;

    const addUrl = window.routes?.cart_add_url || '/cart/add.js';
    const response = await fetch(addUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: existing ? Math.max(quantity - existing.quantity, 1) : quantity,
      }),
    });

    let data = {};
    try {
      data = await response.json();
    } catch {
      data = {};
    }

    if (!response.ok && !isAlreadyInCartError(data)) {
      throw new Error(data.description || data.message || 'Unable to add to cart');
    }
    if (data.status && !isAlreadyInCartError(data)) {
      throw new Error(data.description || data.message || 'Unable to add to cart');
    }
  }

  async function addToCartAndCheckout(form, button) {
    if (!form) return;
    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput || variantInput.disabled || !variantInput.value) return;

    const root = getProductInfo(button) || form.closest('product-info');
    const quantity = getQuantity(root);

    setButtonLoading(button, true);

    try {
      await ensureVariantInCart(variantInput.value, quantity);
      window.location.assign(checkoutUrl());
    } catch (error) {
      console.error(error);
      setButtonLoading(button, false);
      const errorWrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
      const errorMessage = errorWrapper?.querySelector('.product-form__error-message');
      if (errorWrapper && errorMessage) {
        errorWrapper.removeAttribute('hidden');
        errorMessage.textContent = error.message || 'Unable to start checkout. Please try again.';
      }
    }
  }

  function bindBuyNow() {
    if (document.documentElement.dataset.pairfitBuyNowBound === 'true') return;
    document.documentElement.dataset.pairfitBuyNowBound = 'true';

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-pairfit-buy-now], [data-pairfit-sticky-buy]');
      if (!button) return;
      event.preventDefault();
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      const buyNow = document.querySelector('product-info.pairfit-product-page [data-pairfit-buy-now]') || button;
      const form = getProductForm(getProductInfo(buyNow));
      addToCartAndCheckout(form, button);
    });
  }

  function bindStickyAtc() {
    const bar = document.querySelector('[data-pairfit-sticky-atc]');
    const trigger = document.querySelector('product-info.pairfit-product-page .product-form__buttons');
    if (!bar || !trigger || bar.dataset.pairfitBound === 'true') return;
    bar.dataset.pairfitBound = 'true';

    const addButton = bar.querySelector('[data-pairfit-sticky-add]');

    addButton?.addEventListener('click', () => {
      document.querySelector('product-info.pairfit-product-page .product-form__submit')?.click();
    });

    const mediaQuery = window.matchMedia('(max-width: 749px)');
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        const shouldShow = mediaQuery.matches && Boolean(entry) && !entry.isIntersecting;
        bar.hidden = !shouldShow;
        document.body.classList.toggle('pairfit-sticky-atc-visible', shouldShow);
      },
      { threshold: 0 }
    );

    const sync = () => {
      if (!mediaQuery.matches) {
        bar.hidden = true;
        document.body.classList.remove('pairfit-sticky-atc-visible');
        return;
      }
      observer.observe(trigger);
    };

    mediaQuery.addEventListener('change', sync);
    sync();
  }

  function getStockMap(root) {
    const script = root?.querySelector('[data-pairfit-stock-map]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch {
      return null;
    }
  }

  function applyStockMessage(stockEl, { available, quantity, inventoryManagement }) {
    if (!stockEl) return;
    const threshold = Number(stockEl.dataset.lowThreshold || 8);
    const qty = Number(quantity);
    const soldOut = available === false;
    const lowStock =
      available &&
      inventoryManagement === 'shopify' &&
      Number.isFinite(qty) &&
      qty > 0 &&
      qty <= threshold;

    stockEl.classList.toggle('hidden', !soldOut && !lowStock);
    stockEl.classList.toggle('pairfit-pdp-offer__stock--soldout', soldOut);
    if (soldOut) {
      stockEl.textContent = 'Sold out in this size';
    } else if (lowStock) {
      stockEl.textContent = `Only ${qty} left in this size`;
    } else {
      stockEl.textContent = '';
    }
  }

  function updateOfferAndSticky(event) {
    const variant = event.data?.variant;
    if (!variant) return;
    const root = document.querySelector(`product-info[data-section="${event.data.sectionId}"]`) || getProductInfo();
    if (!root) return;

    const stockEl = root.querySelector('[data-pairfit-stock]');
    const nextStock = event.data.html?.querySelector('[data-pairfit-stock]');
    if (stockEl && nextStock) {
      stockEl.className = nextStock.className;
      stockEl.textContent = nextStock.textContent.trim();
    } else if (stockEl) {
      const stockMap = getStockMap(root);
      const mapped = stockMap?.[String(variant.id)];
      applyStockMessage(stockEl, {
        available: mapped?.available ?? variant.available,
        quantity: mapped?.quantity ?? variant.inventory_quantity,
        inventoryManagement: mapped?.inventory_management ?? variant.inventory_management,
      });
    }

    const sticky = document.querySelector('[data-pairfit-sticky-atc]');
    if (sticky) {
      const priceEl = sticky.querySelector('[data-pairfit-sticky-price]');
      const compareEl = sticky.querySelector('[data-pairfit-sticky-compare]');
      if (priceEl) priceEl.textContent = formatMoneyFromCents(variant.price);
      if (compareEl) {
        const onSale = variant.compare_at_price > variant.price;
        compareEl.classList.toggle('hidden', !onSale);
        compareEl.textContent = onSale ? formatMoneyFromCents(variant.compare_at_price) : '';
      }
      const unavailable = !variant.available;
      sticky.querySelectorAll('button').forEach((button) => {
        button.disabled = unavailable;
      });
    }

    root.querySelectorAll('[data-pairfit-buy-now]').forEach((button) => {
      button.disabled = !variant.available;
    });
  }

  function init() {
    bindBuyNow();
    bindStickyAtc();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, updateOfferAndSticky);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
